import { BeneficiaryCopMatchStatus } from "@alpha/bene-dtos/lib/enums/BeneficiaryCopMatchStatus";
import useAlphaSnackbar from "hooks/useAlphaSnackbar";
import useLog from "hooks/useLog";
import { DateTime } from "luxon";
import { useState } from "react";
import { useMutation } from "react-query";
import { getIndividualBeneficiary } from "services/Beneficiaries/beneficiaries.service";

const useDrawdownCOPCheck = () => {
  const [beneficiaryNeedsCOPAcknowledgement, setBeneficiaryNeedsCOPAcknowledgement] = useState<BeneficiaryDto & { paymentId: string } | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const sb = useAlphaSnackbar();
  const { logError } = useLog();
  const getBeneficiary = useMutation(
    'getBeneficiary',
    getIndividualBeneficiary
  );


  const performBeneficiaryCOPValidation = async (beneficiaryId: string, paymentId: string):Promise<boolean> => {
    try {
      setLoading(true);
      const statusToShowCopModal = [BeneficiaryCopMatchStatus.NEAR_MATCH, BeneficiaryCopMatchStatus.MATCH_WRONG_ACCOUNT_TYPE, BeneficiaryCopMatchStatus.NEAR_MATCH_WRONG_ACCOUNT_TYPE];
      
      const copBeneficiary = await getBeneficiary.mutateAsync(beneficiaryId);
      if (copBeneficiary.confirmationOfPayee) {
        if (statusToShowCopModal.includes(copBeneficiary.confirmationOfPayee.Status)) {
          if (
            copBeneficiary.confirmationOfPayee.ApprovedAt &&
            DateTime.fromISO(copBeneficiary.confirmationOfPayee.ApprovedAt).diffNow('years').years < 1
          ) {
            return false;
          }
          setBeneficiaryNeedsCOPAcknowledgement({ ...copBeneficiary, paymentId: paymentId });
          return true;
        }
      }
      return false;
    } catch (error) {
      sb.trigger(t('error_loading_beneficiary'), 'error');
      logError({ action: 'Error loading beneficiary', error });
      return false;
    } finally {
      setLoading(false);
    }
  };
  return {
    beneficiaryNeedsCOPAcknowledgement,
    setBeneficiaryNeedsCOPAcknowledgement,
    performBeneficiaryCOPValidation,
    loading,
  }
};

export default useDrawdownCOPCheck;